<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">绑定400号码</h1>
            <div class="mobile-bind-group">
                <p>注：</p>
                <p>1、公共大号类型：与站点为1对多的关系;</p>
                <p>2、独立大号类型：与站点为1对1的关系;</p>
                <p>3、已绑定独立大号的站点不允许再新增绑定公共大号;</p>
                <p>4、月最低消费输入0代表按照实际通话进行扣费;</p>
                <p>5、使用公共大号时，月最低消费配置不生效，均按实际通话进行扣费;</p>
            </div>
            <el-form class="form-container" :model="hotlineInfo" :rules="hotlineRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">号码类型</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="type">
                            <el-select v-model="hotlineInfo.type" @change="selectChanged">
                                <el-option value="1" label="独立大号"></el-option>
                                <el-option value="2" label="公共大号"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">400号码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="id">
                            <el-select v-model="hotlineInfo.id" @change="handleChange" >
                                <template v-if="this.activeType==1">
                                    <el-option v-for="(item, key) in hotlines" :key="key" :value="item" :label=" + item.only_user_400 == 1 ? item.hotline_number+' ( 直拨号 )' : item.hotline_number"></el-option>
                                </template>
                                <template v-if="this.activeType==2">
                                    <el-option v-for="(item, key) in hotlines" :key="key" :value="item" :label="+item.hotline_number+' ( '+item.telephone_length+' 位分机号，已占用分机号 '+item.telephone_total+' 个 )'"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">月最低消费</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="minimum_charge_yuan">
                            <el-input placeholder="请输入月最低消费"  v-model="hotlineInfo.minimum_charge_yuan">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">保 存</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { validateNumber } from '@/utils/validate'
    import { getHotlinesForBind } from '@/service/hotline'
    export default {
        name: "bindLine",
        components: {
            PopoverRight
        },
        data () {
            return {
                hotlineInfo: {
                    id: '',
                    type: '',
                    hotline_number: '',
                    minimum_charge_yuan: '',
                    telephone_length: '',
                    only_user_400: '',
                    site_id:'',
                },
                hotlineRules: {
                    type: [
                        { required: true, message: '请选择号码类型', trigger: 'blur' },
                        {  result: '号码类型', trigger: 'blur',
                            validator:validateNumber, type:1 }
                    ],
                    id: [
                        { required: true, message: '请选择400号码', trigger: 'blur' },
                    ],
                    minimum_charge_yuan: [
                        { required: true, message: '请填写0-9999之间的月最低消费', trigger: 'blur' },
                        {  result: '月最低消费', trigger: 'blur',
                            validator:validateNumber, type:1,max: 9999,min:0, }
                    ],
                },
                hotlines:[],
                activeType:null,
            }
        },
        methods: {
            open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide();
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            async getHotlinesForBind (query) {
                this.isLoading = true;
                await getHotlinesForBind(query).then((data) => {
                    this.hotlines = data
                });
                this.isLoading = false
            },
            selectChanged (value) {
                this.activeType=value;
                this.getHotlinesForBind({'type':value,'site_id':this.hotlineInfo.site_id})
            },
            handleChange (params) {
                this.hotlineInfo.hotline_id = params.id;
                this.hotlineInfo.hotline_number = params.hotline_number;
                this.hotlineInfo.telephone_length = params.telephone_length;
                this.hotlineInfo.only_user_400 = params.only_user_400;
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        this.hide();
                        this.hotlineInfo.minimum_charge=this.hotlineInfo.minimum_charge_yuan
                        this.$parent.appendHotline(this.hotlineInfo);
                    }
                })
            },
        }
    }
</script>

<style scoped>
.mobile-bind-group{
    margin-top: 15px;
    line-height: 24px;
    font-size: 13px;
    color: #999;
    background: #fafafa;
    padding: 10px 20px;
}
.popover-slider-bar .form-container .form-item .form-label{
  width:90px!important;
}
</style>